import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.447 20.478c.003-.03.004-.06.005-.09v-7.202h2.461c.395 0 .75-.26.808-.65a5.733 5.733 0 0 0-.007-1.652c-.057-.383-.398-.635-.786-.635h-2.476c0-2.22.369-2.543 2.45-2.584.4-.007.758-.27.817-.666a5.67 5.67 0 0 0-.003-1.654c-.056-.377-.395-.623-.776-.62-3.68.032-5.775.467-5.775 5.523H7.259c-.37 0-.7.233-.756.599a5.68 5.68 0 0 0 .005 1.662c.057.402.42.677.825.677h1.832V20.5c-2.849-.019-4.888-.131-6.216-.24a2.93 2.93 0 0 1-2.707-2.707C.124 16.099 0 13.79 0 10.5c0-3.29.124-5.597.242-7.051A2.93 2.93 0 0 1 2.949.742C4.403.624 6.711.5 10 .5c3.29 0 5.597.124 7.05.242a2.93 2.93 0 0 1 2.708 2.708C19.876 4.904 20 7.212 20 10.5c0 3.29-.124 5.598-.242 7.052a2.93 2.93 0 0 1-2.707 2.708c-1.063.086-2.58.175-4.604.217Z"
    }, null, -1)
  ]))]))
}
export default { render: render }